import { SUPPORT_EMAIL } from 'utils/constants';

export const DEFAULT_SUBJECT = 'Help with Partners Dashboard Account';

export const DEFAULT_LABEL = `CONTACT ${SUPPORT_EMAIL.toUpperCase()}`;
